module.exports = __webpack_public_path__ + "img/temp-newsletter-block.06e0556e.png";